module.exports = __webpack_public_path__ + "static/media/search-list.16adbe08.svg";